import {
  getParcelDimensionsDisplay,
  OutboundParcel,
} from "@redotech/redo-fulfillment-parcel-common/parcel";

/** The strip we print on carriers that can't take custom fields themselves (UPS Ground Saver). */
export const CARRIER_LABEL_FIELDS_HEIGHT_INCHES = 0.25;

const CARRIER_LABEL_FIELDS_CLASS = "carrier-label-fields";

export function buildCarrierLabelFieldsText({
  orderName,
  customerId,
  packageDimensions,
  productNames,
  skus,
}: {
  orderName: string | undefined;
  customerId: string | undefined;
  packageDimensions?: string;
  productNames?: string[];
  skus?: string[];
}): string | undefined {
  const parts = [
    orderName,
    customerId,
    packageDimensions,
    ...(skus ?? []),
    ...(productNames ?? []),
  ].filter((part): part is string => !!part);
  return parts.length > 0 ? parts.join(" | ") : undefined;
}

export function packageDimensionsLabel(
  parcel: OutboundParcel | null | undefined,
): string | undefined {
  return (parcel && getParcelDimensionsDisplay(parcel)) || undefined;
}

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

/** CSS for the strip; `maxWidthInches` is the page width it prints on. */
export function carrierLabelFieldsCss(maxWidthInches: number): string {
  return `
        .${CARRIER_LABEL_FIELDS_CLASS} {
          font-family: monospace;
          font-size: 14px;
          color: black;
          height: ${CARRIER_LABEL_FIELDS_HEIGHT_INCHES}in;
          line-height: ${CARRIER_LABEL_FIELDS_HEIGHT_INCHES}in;
          padding-left: 4px;
          flex-shrink: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: ${maxWidthInches}in;
        }`;
}

export function carrierLabelFieldsHtml(text: string): string {
  return `<div class="${CARRIER_LABEL_FIELDS_CLASS}">${escapeHtml(text)}</div>`;
}
